import React from 'react';
import { blue600, BodyText, grey600 } from '@paypalcorp/pp-react';
import getSocialCampaign from '../utility/getSocialCampaign';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import SocialShare from '../components/socialShare/socialShare';
import _isEmpty from 'lodash/isEmpty';
import { isInContext } from '../utility/inContextDonation';
import {
  isExternalFlow,
  isCampaigns,
} from '../utility/productIntegrationUtils';
import { EVENT_NAME } from '../utility/constants';
import classNames from 'classnames';
import { trackLinkClick } from '../fpti/fpti';

const { label: copyLinkMessages } = localsMessages('common/copyLink');
const { title = {}, sheet = {} } = localsMessages('common/socialShareMessage');

export default function ConfirmationSocialShare(props) {
  const {
    email,
    hostedButtonId,
    orgName,
    messages: { social },
    personalizedMessages,
    campaignId,
    isLanding = false,
  } = props;
  const { copy, copied } = copyLinkMessages;
  const handleSocialAnalytics = (type) => {
    trackLinkClick(type, {
      eventName: isExternalFlow()
        ? EVENT_NAME.DW_GIVING_SHARE_CHANNEL_PRESSED
        : EVENT_NAME.DONATE_SUCCESS_SHARE_MESSAGE,
    });
  };

  let socialMessages;

  if (personalizedMessages) {
    socialMessages = {
      ...social,
      ...personalizedMessages,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
      sheet,
    };
  } else if (hostedButtonId) {
    socialMessages = {
      ...social,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
      sheet,
    };
  } else {
    socialMessages = {
      ...social,
      ...social.unhosted,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
      sheet,
    };
  }

  const socialCampaign = getSocialCampaign(
    socialMessages,
    orgName,
    hostedButtonId,
    campaignId,
    title,
    email
  );

  const getSocialShareHeader = () => {
    if (personalizedMessages.social_title) {
      return personalizedMessages.social_title;
    } else if (isCampaigns()) {
      return social.shareGeneric;
    } else if (_isEmpty(personalizedMessages)) {
      return social.shareWithMatch;
    }
  };

  const generateSocialShareUrl = () => {
    if (isExternalFlow()) {
      return TemplateData.shareUrl;
    } else if (hostedButtonId) {
      return `${TemplateData.paypalHostName}/donate/?hosted_button_id=${hostedButtonId}&source=url`;
    } else if (campaignId) {
      return `${TemplateData.paypalHostName}/donate/?campaign_id=${campaignId}&source=url`;
    } else if (email) {
      return `${TemplateData.paypalHostName}/donate/?business=${email}&source=url`;
    }
  };

  const socialShareUrl = generateSocialShareUrl();

  const colors = {
    facebook: '#007AFF',
    twitter: '#64D2FF',
  };

  const headerClasses = classNames('text-center', 'social_share_header', {
    inContext: isInContext(),
    externalFlow: isExternalFlow(),
    'campaign-landing': isCampaigns() && isLanding && !TemplateData.ismobile,
  });

  const getShareStyles = () => {
    if (isInContext() && isExternalFlow()) {
      return { marginBottom: '28px' };
    } else if (isCampaigns() && isLanding) {
      return { marginBottom: '48px', flexWrap: 'wrap', rowGap: '14px' };
    }
    return { marginBottom: '74px' };
  };

  return (
    <>
      <BodyText className={headerClasses}>{getSocialShareHeader()}</BodyText>
      {TemplateData.ismobile && isExternalFlow() ? (
        <SocialShare
          shareUrl={socialShareUrl}
          socialCampaign={socialCampaign}
          isMobile={TemplateData.ismobile}
          analytics={handleSocialAnalytics}
          color={colors}
          style={{ marginBottom: '20px' }}
          renderMode="sheet"
          buttonText={personalizedMessages.success_share_button}
        />
      ) : (
        <SocialShare
          shareUrl={socialShareUrl}
          socialCampaign={socialCampaign}
          isMobile={TemplateData.ismobile}
          analytics={handleSocialAnalytics}
          color={isInContext() && isExternalFlow() ? grey600 : blue600}
          style={getShareStyles()}
          align={
            isCampaigns() && isLanding && !TemplateData.ismobile
              ? 'left'
              : 'center'
          }
        />
      )}
    </>
  );
}
